import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Projects API
export const projectsAPI = {
  getAll: () => api.get('/projects'),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
};

// Site Visits API
export const visitsAPI = {
  getByProject: (projectId) => api.get(`/projects/${projectId}/visits`),
  getById: (id) => api.get(`/visits/${id}`),
  create: (data) => api.post('/visits', data),
  update: (id, data) => api.put(`/visits/${id}`, data),
  delete: (id) => api.delete(`/visits/${id}`),
};

// Assessments API
export const assessmentsAPI = {
  getByVisit: (visitId) => api.get(`/visits/${visitId}/assessments`),
  getMandatoryNonCompliant: (visitId) => api.get(`/visits/${visitId}/mandatory-non-compliant`),
  save: (data) => api.post('/assessments', data),
  batchSave: (data) => api.post('/assessments/batch', data),
  delete: (id) => api.delete(`/assessments/${id}`),
};

// Images API
export const imagesAPI = {
  upload: (formData) => api.post('/images/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  uploadMultiple: (formData) => api.post('/images/upload-multiple', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getByVisit: (visitId) => api.get(`/visits/${visitId}/images`),
  getByAssessment: (assessmentId) => api.get(`/assessments/${assessmentId}/images`),
  getImageUrl: (imageId) => `${API_BASE_URL}/images/${imageId}`,
  updateCaption: (id, caption) => api.put(`/images/${id}/caption`, { caption }),
  delete: (id) => api.delete(`/images/${id}`),
};

// Users API
export const usersAPI = {
  getAll: () => api.get('/users'),
  getAssessors: () => api.get('/users/assessors'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
};

// Criteria API
export const criteriaAPI = {
  getAll: () => api.get('/criteria'),
  getByCategory: () => api.get('/criteria/by-category'),
  getById: (id) => api.get(`/criteria/${id}`),
};

// Reports API
export const reportsAPI = {
  generate: (visitId) => api.post(`/visits/${visitId}/generate-report`, {}, {
    responseType: 'blob', // Important for file download
  }),
  getByVisit: (visitId) => api.get(`/visits/${visitId}/reports`),
  download: (reportId) => api.get(`/reports/${reportId}/download`, {
    responseType: 'blob',
  }),
};

export default api;